import React from "react";
import {
  BooleanInput,
  Edit,
  SimpleForm,
  TextField,
  TextInput,
  ArrayInput,
  DateInput,
  SimpleFormIterator,
  required
} from "react-admin";

const SportSeasonEdit = (props) => {
  return (
    <Edit undoable={false} {...props}>
      <SimpleForm>
        <TextField source="sportCode" />
        <TextField source="seasonCode" />
        <BooleanInput source="isCurrent" />
        <ArrayInput source="schedulePeriods">
          <SimpleFormIterator>
            <TextInput source="label" validate={[required()]} />
            <DateInput source="startDate" validate={[required()]} />
            <DateInput source="endDate" validate={[required()]} />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Edit>
  );
};

export default SportSeasonEdit;
